import {httpAction, getAction, postAction} from '@/api/manage'
//驳回
export function reject(that){
  /*if(applicationCode === 'env_audit'){
    epm_reject(that);
  }else if(applicationCode === 'ipsys'){
    ipsys_reject(that);
  }*/
  if(that.model.comments===null||that.model.comments===''||that.model.comments===undefined){
    // that.$message.warning("驳回信息不能为空！");
    that.$message.warning(that.language['eletronicSigned.rejectCommentsNotNull'])
    return;
  }
  postAction("/sys/bpm-signed/process/"+that.model.businessFormNo,{"action":"R","businessFormNo":that.model.businessFormNo,"reviewerId":that.$store.getters.userInfo.workNo,"remarks":that.model.comments}).then(res=>{
    that.confirmLoading = false;
    if (res.success) {
      that.$emit('close');
      // if(that.$refs.applicationModel.hasOwnProperty('checkApprovedCallback')){
      //   that.$refs.applicationModel.checkApprovedCallback()
      // }
    } else {
      that.$message.warning(res.message);
    }
  })
}
function epm_reject(that){
  let map = {};
  map.pfBpmProcessId = that.model.processGuid;
  map.comments = that.model.comments;
  map.workNo = that.$store.getters.userInfo.workNo;
  map.approveAction = "Reject";
  map.taskCode = that.model.taskCode;
  if(map.comments===null||map.comments===''||map.comments===undefined){
    // that.$message.warning("驳回信息不能为空！");
    that.$message.warning(that.language['eletronicSigned.rejectCommentsNotNull'])
    return;
  }
  that.confirmLoading = true;
  postAction("/sys/electronicSigned/envProcess/"+that.model.processGuid, map).then((res) => {
    if (res.success) {
      that.$emit('close');
      that.confirmLoading = false;
    }
  })
}
function ipsys_reject(that) {
  if(that.model.task_code==='ApproveTask8'){
    that.$message.warning(that.language['eletronicSigned.undertakerCannotReject'])
    return;
  }
  let map = {};
  map.processGuid = that.model.process_guid;
  map.taskCode = that.model.task_code;
  map.approverUserCode = that.$store.getters.userInfo.workNo;
  map.comments = that.model.comments;
  map.approveAction = "Reject";
  map.fileList = that.model.filelist;
  if(map.comments===null||map.comments===''||map.comments===undefined){
    // that.$message.warning("驳回信息不能为空！");
    that.$message.warning(that.language['eletronicSigned.rejectCommentsNotNull'])
    return;
  }
  that.confirmLoading = true;
  postAction("/sys/electronicSigned/ipsysProcess/"+that.model.process_guid, map).then((res) => {
    if (res.success) {
      that.$emit('close');
      that.confirmLoading = false;
    }
  })
}